import { gql } from "@apollo/client";
import PRODUCT_FRAGMENT from "@/fragments/product";
const MENU_QUERY = gql`
	${PRODUCT_FRAGMENT}
	query MenuQuery(
		$retailerId: ID!
		$offset: Int!
		$limit: Int!
		$filter: MenuFilter
		$sort: MenuSort
	) {
		menu(
			filter: $filter
			retailerId: $retailerId
			pagination: { offset: $offset, limit: $limit }
			sort: $sort
		) {
			products {
				...productFragment
			}
			productsCount
		}
	}
`;
export default MENU_QUERY;
